//保存配料表解读相关
const state = {
  imageSource: '', // 图片资源原base64资源
  lrzImageSource: '' //压缩图片base64资源
}
const mutations = {
  setImageSource(state, b) {
    state.imageSource = b
  },
  setLrzImageSource(state, b) {
    state.lrzImageSource = b
  }
}
const getters = {}
const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
